import React, { useState, useRef } from 'react';
import useData from '../../hooks/useData';
import useToast from '../../hooks/useToast';
import { ProjectIcon, GroupIcon, EditIcon } from '../ui/Icons';
import useClickOutside from '../../hooks/useClickOutside';
import { createPortal } from 'react-dom';

// --- INÍCIO DA ALTERAÇÃO 1: O dropdown agora aceita a propriedade `direction` ---
const ConnectionSelectorDropdown = ({ options, value, onSave, placeholder, direction = 'down' }) => {
// --- FIM DA ALTERAÇÃO 1 ---
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });

    const openDropdown = () => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            const dropdownWidth = 200; // min-w-[200px]
            // --- INÍCIO DA ALTERAÇÃO 2: Lógica para calcular a posição com base na direção ---
            const estimatedDropdownHeight = 192; // max-h-48 approx.

            let topPosition;
            if (direction === 'up') {
                topPosition = rect.top - estimatedDropdownHeight - 8; // Abre para cima
            } else {
                topPosition = rect.bottom + 8; // Abre para baixo (padrão)
            }
            // --- FIM DA ALTERAÇÃO 2 ---

            setPosition({
                top: topPosition,
                left: rect.right - dropdownWidth
            });
            setIsOpen(true);
        }
    };

    useClickOutside(dropdownRef, () => setIsOpen(false), buttonRef);

    const displayLabel = options.find(opt => opt.value === value)?.label || placeholder;

    const DropdownMenu = () => (
        <div
            ref={dropdownRef}
            style={{
                position: 'fixed',
                top: `${position.top}px`,
                left: `${position.left}px`,
                minWidth: '200px',
                zIndex: 1000
            }}
            className="bg-gray-800/90 backdrop-blur-lg border border-white/10 rounded-lg shadow-xl p-2 animate-fade-in"
        >
            <ul className="max-h-48 overflow-y-auto">
                {options.map(option => (
                    <li key={option.value}>
                        <button
                            onClick={() => {
                                onSave(option.value);
                                setIsOpen(false);
                            }}
                            className="w-full text-left p-2 rounded hover:bg-white/10 text-white"
                        >
                            {option.label}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );

    return (
        <div className="relative w-full">
            <button
                ref={buttonRef}
                onClick={openDropdown}
                className="w-full flex items-center justify-end gap-2 p-1 rounded-md text-sm border-2 border-transparent hover:border-white/20 hover:bg-white/10 transition-all duration-200"
            >
                <span className="text-white truncate">{displayLabel}</span>
                <EditIcon size={14} className="text-gray-400" />
            </button>
            {isOpen && createPortal(<DropdownMenu />, document.getElementById('portal-root'))}
        </div>
    );
};

const ConnectionsWidget = ({ task }) => {
    const { projects, clients, handleUpdateTask } = useData();
    const { showToast } = useToast();

    const handleSave = (field, value) => {
        handleUpdateTask(task.id, { [field]: value }, `alterou ${field}`);
        showToast(`${field.charAt(0).toUpperCase() + field.slice(1)} atualizado!`);
    };

    const projectOptions = [{ value: '', label: 'Nenhum' }, ...projects.map(p => ({ value: p.id, label: p.name }))];
    const clientOptions = [{ value: '', label: 'Nenhum' }, ...clients.map(c => ({ value: c.name, label: c.name }))];    
    
    return (
        <div className="space-y-3 text-sm">
            <h3 className="text-sm font-semibold text-gray-400 mb-2">Conexões</h3>
            
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <ProjectIcon size={16} className="text-gray-400" />
                    <span className="text-gray-400 font-medium">Projeto:</span>
                </div>
                <div className="w-40">
                    <ConnectionSelectorDropdown
                        options={projectOptions}
                        value={task.projectId}
                        onSave={(v) => handleSave('projectId', v)}
                        placeholder="Nenhum"
                        // direction="up" // Dropdown de projeto abrirá para baixo (padrão)
                    />
                </div>
            </div>

            <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <GroupIcon size={16} className="text-gray-400" />
                    <span className="text-gray-400 font-medium">Cliente:</span>
                </div>
                <div className="w-40">
                    {/* --- INÍCIO DA ALTERAÇÃO 3: Adicionando a prop `direction="up"` ao dropdown de cliente --- */}
                    <ConnectionSelectorDropdown
                        options={clientOptions}
                        value={task.client}
                        onSave={(v) => handleSave('client', v)}
                        placeholder="Nenhum"
                        direction="up"
                    />
                    {/* --- FIM DA ALTERAÇÃO 3 --- */}
                </div>
            </div>
        </div>
    );
};

export default ConnectionsWidget;